import React, { useState } from 'react';
import './FullScreenOverlay.css'; 
import { useNavigate } from 'react-router-dom';


const FullScreenOverlay = () => {
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();


  const closeOverlay = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    navigate(-1); 
    return null;
  }
  

  return (
    <div className="overlay">
      <button className="close-btn" onClick={closeOverlay}>×</button>


      <div className="white">
        <div className="black">    
      <form className="d-flex" role="search">    
    <input className='input' type="input-text"  placeholder="Search 'kurti' for demo search... " name="" id="" />
    
    
      <button className="btn" type="submit" style={{color:"white"}}><i class="fa-solid fa-magnifying-glass"></i></button>
    </form></div>
      </div>

    </div>
  );
};

export default FullScreenOverlay;

